import { MERCH, YOUTUBE } from "constants/links";

import { Grid } from "@mui/material";
import stosujTutorial from "assets/images/stosuj-tutorial.jpg";
import stosujWebinare from "assets/images/stosuj-webinare.jpg";
import stosujYoutube from "assets/images/stosuj-youtube.jpg";
import SectionCard from "components/elements/SectionCard";
import { useTranslation } from "react-i18next";

import Card from "./Card";
import MerchCoupon from "./MerchCoupon";
import Socials from "./Socials";

const ITEMS = [
  {
    id: "tutorials",
    primaryHrefLink: "https://www.youtube.com/watch?v=uuMalJpmHnM",
    secondaryLink: "/proc-bitcoin/jak-vam-stosuj-cz-pomuze",
    img: stosujTutorial,
  },
  {
    id: "webinars",
    primaryHrefLink: "/webinare",
    secondaryHrefLink: "/21-duvodu-proc-stosuj",
    img: stosujWebinare,
  },
  {
    id: "youtube",
    primaryHrefLink: YOUTUBE,
    img: stosujYoutube,
    customSecondary: <Socials />,
  },
  {
    id: "merch",
    primaryHrefLink: MERCH,
    videoId: "43Y2uUstFzE",
    customBottom: <MerchCoupon />,
  },
];

const CommunityHub = () => {
  const { t } = useTranslation();

  return (
    <SectionCard title={t("dashboard.communityHub.title")}>
      <Grid container spacing={3}>
        {ITEMS.map((item) => (
          <Grid item xs={12} md={6} key={item.id}>
            <Card {...item} />
          </Grid>
        ))}
      </Grid>
    </SectionCard>
  );
};

export default CommunityHub;
